import { render, staticRenderFns } from "./SloganBlock.vue?vue&type=template&id=d5376b8c"
import script from "./SloganBlock.vue?vue&type=script&lang=js"
export * from "./SloganBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports